module.exports = "<p>\r\n  You do not have access to this page.\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forbidden-page/forbidden-page.component.html
// module id = ./src/app/forbidden-page/forbidden-page.component.html
// module chunks = main